import { PageTitle } from 'application/Shared/Components/App';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ManageWorkatoManifests } from './Components/ManageWorkatoManifests';

export const ManageManifestsDashboard = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle title={t('Admin.Manifests.title')} />
            <ManageWorkatoManifests />
        </>
    );
};
